export const moduleSlug = "phygital";
export const moduleAuth = "Phygital";

export const children = [
// phygital routes 
  {
    path: "",
    component: () => import("./pages/PhygitalLinks.vue"),
    props: {
      selectedModule: moduleSlug
    },
    meta: {
      title: "Phygital Links",
      linkTitle: "Phygital Links",
      linkIcon: "link",
      showInNav: true,
      permission: "Phygital.Read",
    },
  },
  {
    path: "create",
    component: () => import("./pages/PhygitalLinkCreate.vue"),
    props: {
      selectedModule: moduleSlug
    },
    meta: {
      title: "Generate Phygital Link",
      linkTitle: "Generate Phygital Link",
      linkIcon: "link",
      showInNav: false,
      permission: "Phygital.Create",
    },
  },
  {
    path: "edit/:id",
    component: () => import("./pages/PhygitalLinkCreate.vue"),
    props: {
      selectedModule: moduleSlug
    },
    meta: {
      title: "Generate Phygital Link",
      linkTitle: "Generate Phygital Link",
      linkIcon: "link",
      showInNav: false,
      permission: "Phygital.Create",
    },
  },

// Url shorteners  routes 
  {
    path: 'urls',
    component: () => import('@/modules/UrlShortener/pages/UrlShortener.vue'),
    props: {
      selectedModule: moduleSlug
    },
    meta: {
      title: 'Url-Shortener Dashboard',
      linkTitle: 'Urls',
      linkIcon: 'qrcode',
      showInNav: true,
      permission: "UrlShortener.Read",
    }
  },
  {
    path: 'urls/create',
    component: () => import('@/modules/UrlShortener/pages/CreateShortUrl.vue'),
    props: {
      selectedModule: moduleSlug
    },
    meta: {
      title: 'Url Creation',
      showInNav: false,
      permission: "UrlShortener.Create",
    }
  },
  {
    path: 'urls/analytics',
    component: () => import('@/modules/UrlShortener/pages/UrlAnalytics.vue'),
    props: {
      selectedModule: moduleSlug
    },
    meta: {
      title: 'Url Analytics',
      linkTitle: 'Analytics',
      linkIcon: 'bar-chart',
      showInNav: false,
      permission: "UrlShortener.Read",
    }
  },
];
